export default function languageSelect() {
  const languageSelects = document.querySelectorAll('.o-meta-navigation__language-select');

  languageSelects.forEach((select) => {
    select.addEventListener('change', () => {
      const selectedOption = select.options[select.selectedIndex];
      const target = selectedOption?.value || selectedOption?.dataset?.href;

      if (target) {
        window.location.href = target;
      }
    });
  });
}
